import { useContext } from 'react';
import TemplateText from 'survey/components/TemplateText';
import { AppState } from 'survey/types';
import AppContext from 'survey/contexts/AppContext';
import AgentConnectLogoDark from 'survey/assets/images/agent_connect_dark.png';

const utmCampaign = 'ftr';
const utmMedium = 'web';
const utmSource = 'sc';
const baseUrl = 'https://www.medallia.com';

const Footer = (): JSX.Element | null => {
  const appContext = useContext<AppState>(AppContext);
  const defaultPrivacyUrl = `${baseUrl}/privacy-policy`;
  const defaultAboutUrl = `${baseUrl}/products/agent-connect/?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_content=${appContext.brand.name}&utm_campaign=${utmCampaign}`;

  if (!appContext.employee) return null;

  const {
    links: { about_us: aboutUrl, privacy_policy: privacyUrl },
    texts: { footer: surveyTranslationFooterText },
    footer: {
      text: dynamicTextsFooterText,
      powered_by: poweredByText,
      privacy_policy: privacyText,
      unsubscribe: unsubscribeText,
      hide: hideFooter,
    },
    unsubscribe_url: unsubscribeUrl,
  } = appContext;

  const footerText = surveyTranslationFooterText || dynamicTextsFooterText;

  return (
    <div className="row justify-content-center">
      <footer
        className="branded-footer text-center col-xs-12 col-sm-8 col-md-6"
        data-testid="footer"
      >
        {!!footerText && (
          <div className="email-footer dynamic-text" aria-label={footerText}>
            <TemplateText escape={false} allowATags text={footerText} />
          </div>
        )}

        {!hideFooter && (
          <div className="powered-by">
            <a
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-us-logo"
              href={aboutUrl || defaultAboutUrl}
            >
              <span>{poweredByText}</span>
              <img src={AgentConnectLogoDark} alt="Agent Connect logo" />
            </a>
          </div>
        )}

        <div className="row justify-content-center">
          <a
            className="d-block"
            target="_blank"
            rel="noreferrer noopener"
            data-testid="unsubscribe-link"
            href={unsubscribeUrl}
          >
            {unsubscribeText}
          </a>

          <a
            href={privacyUrl || defaultPrivacyUrl}
            className="d-block"
            rel="noreferrer noopener"
            data-testid="privacy-link"
            target="_blank"
          >
            {privacyText}
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
